import {
	type FetchNftExternalAddressesParams,
	type PostNftExternalAddressPayload,
	type PutNftExternalAddressByExternalAddressIdPayload
} from '@capsicum/common';

import { nftApi } from '.';

export async function fetchExternalAddresses(params: FetchNftExternalAddressesParams) {
	return (await nftApi)
		.fetchNftExternalAddresses({
			...params
		})
		.then(res => res.data);
}

export async function fetchExternalAddressById(externalAddressId: string) {
	return (await nftApi).fetchNftExternalAddressByExternalAddressId(externalAddressId).then(res => res.data);
}

export async function postExternalAddress(payload: PostNftExternalAddressPayload) {
	return (await nftApi).postNftExternalAddress(payload);
}

export async function putExternalAddress(id: string, payload: PutNftExternalAddressByExternalAddressIdPayload) {
	return (await nftApi).putNftExternalAddressByExternalAddressId(id, payload);
}
